import React from 'react';
import PropTypes from 'prop-types';
import TrendBadge from 'views/atoms/badges/TrendBadge';
import 'stylesheets/ScorePage/ChartWithBadgeWrapperMolecule.scss';

const ChartWithBadgeWrapperMolecule = ({ children, trendBadge, color = 'white' }) => {
  return (
    <div className="chart-with-badge-wrapper">
      <div className="chart-with-badge-wrapper__content">
        {children}
      </div>

      {trendBadge && (
        <div className="chart-with-badge-wrapper__badge-container">
          <TrendBadge 
            trendBadge={trendBadge} 
            size="medium"
            color={color}
          />
        </div>
      )}
    </div>
  );
};

ChartWithBadgeWrapperMolecule.propTypes = {
  children: PropTypes.node.isRequired,
  trendBadge: PropTypes.shape({
    symbol: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }),
  color: PropTypes.oneOf(['auto', 'auto-inverse', 'white', 'planet']), 
};

export default ChartWithBadgeWrapperMolecule;